<template>
  <div class="relative">
    <slot></slot>
    <div v-if="heading" class="absolute inset-0 py-16 flex" :class="alignmentClasses.vertical">
      <div class="container flex relative z-10 w-full" :class="alignmentClasses.horizontal">
        <div class="space-y-4 w-full max-w-4xl" :class="alignmentClasses.text">
          <span
            v-if="tag"
            class="btn-tag whitespace-nowrap text-br-green bg-blackly border-blackly border inline-block"
            >{{ tag }}</span
          >
          <TagBtn v-if="secondaryCta.length" :to="secondaryCta[0].element?.uri" class="inline-block">
            {{ secondaryCta[0].text }}
          </TagBtn>
          <BarText tag="h2" :text="heading" :class="headingSize === 'large' ? 'fluid-5xl' : 'fluid-4xl'" />
          <p v-if="teaser" v-html="teaser" class="text-white text-lg"></p>
          <div>
            <LinkField
              v-if="cta[0] && cta[0].text"
              v-track:view="gtmData()"
              v-track:click="gtmData()"
              trackingName="fullWidthHeadingCta"
              typeName="fullWidthHeading"
              v-bind="cta[0]"
              class="mt-4 btn-pill-outline-white inline-block"
              :class="buttonPrimary ? 'btn-pill-black border-none' : 'btn-pill-outline-white'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LinkField from '@/components/common/LinkField';
import BarText from '@/components/BarText';
import TagBtn from '@/components/common/TagBtn';

const route = useRoute();

const props = defineProps({
  boxPosition: {
    type: String,
    default: 'topLeft',
  },
  tag: {
    type: String,
    default: '',
  },
  heading: {
    type: String,
    required: true,
  },
  headingSize: {
    type: String,
    default: 'default',
  },
  teaser: {
    type: String,
    default: '',
  },
  cta: {
    type: Array,
    default: () => [],
  },
  secondaryCta: {
    type: Array,
    default: () => [],
  },
  buttonPrimary: {
    type: Boolean,
    default: false,
  },
});

const alignmentClasses = computed(() => {
  const position = props.boxPosition?.toLowerCase() ?? 'middleright';

  let vertical = 'items-end';
  if (position.includes('top')) {
    vertical = 'items-end md:items-start';
  } else if (position.includes('middle')) {
    vertical = 'items-end md:items-center';
  } else if (position === 'center') {
    vertical = 'items-end md:items-center';
  }

  let horizontal = 'justify-start';
  let textAlign = 'text-left';

  if (position.includes('right') || position === 'middleRight') {
    horizontal = 'justify-end';
    textAlign = 'text-right';
  } else if (position === 'center') {
    horizontal = 'justify-center';
    textAlign = 'text-center';
  }

  return {
    vertical,
    horizontal,
    text: textAlign,
  };
});

const gtmData = () => {
  return {
    promotion_id: props.cta[0]?.element?.uri,
    promotion_name: [route?.name, stripHtml(props.heading)].join(' / '),
    creative_name: 'fullWidthTeaser',
    creative_slot: [route?.name, props.blockPosition + 1].join(' / '),
  };
};
</script>
